module.exports = __webpack_public_path__ + "media/img/illustrations/icons/filter-export-ef4ff57ef8fee83822847c14d7be6a3c.svg";